import Vue from 'vue'
import ECharts from 'vue-echarts'
import './walden'
import 'echarts/lib/chart/sunburst'
import 'echarts/lib/chart/heatmap'
import 'echarts/lib/component/visualMap'
import 'echarts/lib/component/grid'
import 'echarts/lib/component/tooltip'

Vue.component('v-chart', ECharts)